import $ from "jquery"

function b64toBlob(b64Data: any, contentType: any, sliceSize?: any) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = window.atob(b64Data);
    var byteArrays: any[] = [];

    var offset;
    for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        var i;
        for (i = 0; i < slice.length; i = i + 1) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new (window as any).Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new window.Blob(byteArrays, {
        type: contentType
    });
    return blob;
}

var template = { excel: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>' };

var base64 = function (s: any) {
    return window.btoa((window as any).unescape(encodeURIComponent(s)));
};

var format = function (s: any, c: { worksheet: string, table: any }) {
    let clonedTable = $(c.table).clone();
    let itemsToRemove = clonedTable.find(".dropdown-menu");
    itemsToRemove.remove();
    clonedTable.find("input")
        .each((index, el) => {
            $(el).parent().find(".input-group-text").remove();
            $(el).replaceWith("<span>" + (el as any).value + "</span>");
        });
    let htmlTable = clonedTable[0].innerHTML;
    let v = { worksheet: c.worksheet, table: htmlTable };
    return s.replace(new RegExp("{(\\w+)}", "g"), function (m: any, p: any) {
        return (v as any)[p];
    });
};


var get = function (element: any) {
    if (!element.nodeType) {
        return document.getElementById(element);
    }
    return element;
};

var fixCSVField = function (value: string, columnDelimiter: string, decimalSeparator: string, isHeader: boolean) {
    var fixedValue = tryFixNumber(replaceCRLF(value), decimalSeparator);
    var addQuotes = (value.indexOf(columnDelimiter) !== -1);
    var replaceDoubleQuotes = (value.indexOf('"') !== -1);

    if (replaceDoubleQuotes) {
        fixedValue = fixedValue.replace(/"/g, '""');
    }
    if (addQuotes || replaceDoubleQuotes) {
        fixedValue = '"' + fixedValue + '"';
    }

    return fixedValue;
};

var IsNumeric = function (num: string) { return /^-{0,1}\d*\.{0,1}\d+$/.test(num) };

var tryFixNumber = function (value: string, decimalSeparator: string) {
    var x = value.replace(",", ".");
    if (IsNumeric(x)) {
        return x.replace(/[\.,]/g, decimalSeparator);
    }

    return value;
}

var replaceCRLF = function (value: string) {
    return value.replace("\r", "").replace("\n", "");
}

var tableToCSV = function (data: string[][], hasHeaders: boolean, columnDelimiter: string, decimalSeparator: string, quoteText: boolean, newLine: string) {

    let rows: string[] = [];

    for (let ixrow = 0; ixrow < data.length; ixrow++) {
        const row = data[ixrow];
        let buffer: string[] = [];
        for (let ixcell = 0; ixcell < row.length; ixcell++) {
            const cell = row[ixcell];
            buffer.push(fixCSVField(cell.trim(), columnDelimiter, decimalSeparator, ixcell === 0))
        }
        rows.push(buffer.join(columnDelimiter))
    }

    return rows.join(newLine);
};

function createDownloadLink(anchor: any, base64data: any, exporttype: any, filename: string) {
    var blob;
    const msSaveBlob = (window.navigator as any).msSaveBlob;
    if (msSaveBlob) {
        blob = b64toBlob(base64data, exporttype);
        msSaveBlob(blob, filename);
        return false;
    } else if (window.URL.createObjectURL) {
        blob = b64toBlob(base64data, exporttype);
        var blobUrl = window.URL.createObjectURL(blob);
        anchor.href = blobUrl;
    } else {
        var hrefvalue = "data:" + exporttype + ";base64," + base64data;
        anchor.download = filename;
        anchor.href = hrefvalue;
    }

    return true;
}

export let tableToExcel = (anchor: Element | Text, table: Element | Text | string, sheetName?: string) => {
    let tableElement = get(table);
    var ctx = { worksheet: sheetName || 'Worksheet', table: tableElement };
    var b64 = base64(format(template.excel, ctx));
    return createDownloadLink(anchor, b64, 'application/vnd.ms-excel', 'export.xls');
}

export let tableToCsv = (anchor: Element | Text, data: string[][], hasHeaders: boolean, columnDelimiter: string, decimalSeparator: string, newLine: string = "\r\n") => {

    var csvData = "\uFEFF" + tableToCSV(data, hasHeaders, columnDelimiter, decimalSeparator, false, newLine);
    var b64 = base64(csvData);
    return createDownloadLink(anchor, b64, 'application/csv', 'export.csv');
}
